@if (loading()) {
  <div class="map-loading">
    <x-spinner />
  </div>
}
<div #mapContainer class="map-container"></div>
